<template>
  <v-container>
    <v-row
      v-if="planAdded"
      class="mx-auto"
    >
      <v-col cols="12">
        Plan {{ selectedPlan.display_text }} successfully added!
      </v-col>
      <v-col cols="12">
        <v-btn
          color="secondary"
          text
          @click="resetForm"
        >
          Reset
        </v-btn>
        <v-btn
          color="success"
          text
          @click="doCloseForm"
        >
          Close
        </v-btn>
      </v-col>
    </v-row>
    <v-row
      v-else
    >
      <v-col>
        <v-form
          class="mx-2"
        >
          <v-row>
            <v-select
              v-model="currentObject.plan"
              :items="filteredPlans"
              item-text="display_text"
              item-value="Id"
            >
              <template v-slot:label>
                <span class="frm-textbox mb-1">Plan</span>
              </template>
            </v-select>
          </v-row>
          <v-row>
            <v-select
              v-model="currentObject.frequency"
              :items="optsBillingFreq"
            >
              <template v-slot:label>
                <span class="frm-textbox mb-1">Billing Frequency</span>
              </template>
            </v-select>
          </v-row>
          <v-row>
            <v-text-field
              v-model="currentObject.quantity"
              type="number"
            >
              <template v-slot:label>
                <span class="frm-textbox mb-1">Quantity</span>
              </template>
            </v-text-field>
          </v-row>
          <v-row>
            <v-col cols="8">
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="currentObject.date"
                    label="Start Billing On"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  >
                    <template v-slot:label>
                      <span class="frm-textbox mb-1">Start Billing On</span>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="currentObject.date"
                  no-title
                  scrollable
                  @input="menu = false"
                >
                </v-date-picker>
              </v-menu>

            </v-col>
            <v-col cols="4">
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="primary"
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    Presets
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item>
                    Text
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>
          </v-row>
          <v-alert
            v-if="formErrors.length > 0"
            type="error"
          >
            <v-list
              color="error"
            >
              <v-list-item
                v-for="(error, i) in formErrors"
                :key="`error-${i}`"
              >
                {{ error }}
              </v-list-item>

            </v-list>
          </v-alert>
          <v-row>
            <v-spacer></v-spacer>
            <v-btn
              text
              color="warning"
              @click="doCloseForm"
            >
              Cancel
            </v-btn>
            <v-btn
              text
              color="success"
              @click="doAssignPlan"
            >
              Submit
            </v-btn>
          </v-row>
          <v-overlay :value="overlayDisplay">
            <v-progress-circular
              indeterminate
              size="64"
            ></v-progress-circular>
          </v-overlay>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import basicMixin from '../../mixins/basic'
  import {
    _COMMIT_LOG, ACCT_ASSIGN_PLAN, ACCT_GET_ACCOUNT_RATES, PLAN_GET_PLANS,
  } from '../../store/actions.types'

  export default {
    // events
    // formClosed
    name: 'AccountAddPlan',

    mixins: [basicMixin],

    props: {
      item: {
        type: Object,
        default: () => ({
          Id: null,
          Name: '',
          Ip: '',
          Mac: '',
          Type: '',
          Value: '',
          status: '',
          Firmware: '',
          max_subs: 0,
          Heading: 0,
          BeamWidth: 0,
          Range: 0,
          Frequency: 0,
          ChannelWidth: 0,
          ColorCode: '',
          wireless_pass: '',
          fk_tower_id: 0,
          fk_type_id: 0,
          Deleted: false,
        }),
      },
    },
    data: () => ({
      baseObject: {
        plan: null,
        frequency: null,
        quantity: 1,
        date: '',
      },
      currentObject: {
      },
      menu: false,
      formMode: 'read',
      formErrors: [],
      overlayAbsolute: true,
      overlayDisplay: false,
      planAdded: false,
    }),

    computed: {
      ...mapGetters(['isLoggedIn', 'profile', 'apTypes', 'apStatuses', 'towers', 'optsBillingFreq', 'acctSelectedAccount']),
      ...mapGetters('planModule', {
        allPlans: 'list',
        findPlan: 'find',
      }),
      filteredPlans: function () {
        return this.allPlans.filter((plan) => {
          return plan.fk_store_key === this.acctSelectedAccount.fk_store_key
        })
      },
      selectedPlan: function () {
        return this.findPlan(this.currentObject.plan)
      },
    },
    watch: {
    },
    created () {
      this.init()
    },
    methods: {
      ...mapActions({
        commitLog: _COMMIT_LOG,
        assignPlan: ACCT_ASSIGN_PLAN,
        getAccountRates: ACCT_GET_ACCOUNT_RATES,
      }),
      ...mapActions('planModule', {
        getPlans: PLAN_GET_PLANS,
      }),
      async init () {
        this.commitLog({ message: `Initializing ${name} setting values!`, item: this.item })
        this.resetForm()
        await this.getPlans()
      },
      async doAssignPlan () {
        this.overlayDisplay = true
        const formValid = this.doVerifyForm()
        if (!formValid) {
          this.overlayDisplay = false
          return
        }
        try {
          const assignPayload = {
            account_key: this.acctSelectedAccount.rowkey,
            planId: this.currentObject.plan,
            frequency: this.currentObject.frequency,
            quantity: this.currentObject.quantity,
            bill_date: this.currentObject.date,
          }
          const responseData = await this.assignPlan(assignPayload)
          if (responseData.success) {
            this.planAdded = true
            await this.getAccountRates()
          } else {
            this.formErrors.push(responseData.responseText)
          }
        } catch (e) {
          console.log(e)
          this.formErrors = e.problems
        }
        this.overlayDisplay = false
      },
      doVerifyForm () {
        this.formErrors = []
        if (!this.currentObject.plan) {
          this.formErrors.push('A plan must be selected')
        }
        if (!this.currentObject.frequency) {
          this.formErrors.push('Billing frequency must be selected')
        }
        if (!this.currentObject.date || this.currentObject.date === '') {
          this.formErrors.push('Billing date must be selected')
        }
        return this.formErrors.length === 0
      },
      resetForm () {
        const date = this.currentObject.date
        this.currentObject = { ...this.baseObject }
        this.currentObject.date = date
        this.formErrors = []
        this.overlayDisplay = false
        this.planAdded = false
      },
      doCloseForm () {
        this.resetForm()
        this.$emit('closeForm')
      },
    },

  }
</script>
